import { DataAnalysisPage } from '@icoach/dataAnalysis';
import { CLUB_DATA_ANALYSIS_ROUTER } from '@icoach/router/routerPath';

const dataAnalysisRouter = [
    {
        description: '營運報表',
        exact: true,
        path: CLUB_DATA_ANALYSIS_ROUTER.TABS,
        href: CLUB_DATA_ANALYSIS_ROUTER.BASE,
        as: DataAnalysisPage,
        frontKey: 'C5X01',
    },
    {
        description: '目標進度',
        exact: true,
        path: CLUB_DATA_ANALYSIS_ROUTER.TABS,
        as: DataAnalysisPage,
        frontKey: 'C5X02',
    },
    {
        description: '會籍',
        exact: true,
        path: CLUB_DATA_ANALYSIS_ROUTER.TABS,
        as: DataAnalysisPage,
        frontKey: 'C5X03',
    },
    {
        description: '服務',
        exact: true,
        path: CLUB_DATA_ANALYSIS_ROUTER.TABS,
        as: DataAnalysisPage,
        frontKey: 'C5X04',
    },
    {
        description: '顧客製造',
        exact: true,
        path: CLUB_DATA_ANALYSIS_ROUTER.TABS,
        as: DataAnalysisPage,
        frontKey: 'C5X05',
    },
    {
        description: '非會籍',
        exact: true,
        path: CLUB_DATA_ANALYSIS_ROUTER.TABS,
        as: DataAnalysisPage,
        frontKey: 'C5X06',
    },
    {
        description: '教練',
        exact: true,
        path: CLUB_DATA_ANALYSIS_ROUTER.TABS,
        as: DataAnalysisPage,
        frontKey: 'C5X07',
    },
    {
        description: '管理',
        exact: true,
        path: CLUB_DATA_ANALYSIS_ROUTER.TABS,
        as: DataAnalysisPage,
        frontKey: 'C5X08',
    },
];

export default dataAnalysisRouter;
